import $ from "jquery";

const closePopup = () => {
  $(document).on("click", "#mi-close-popup", function (event) {
    // eslint-disable-next-line no-undef
    elementorProFrontend.modules.popup.closePopup({}, event);
  });
};

try {
  closePopup();
} catch (error) {
  console.error("Custom Reorder", error);
}
